export const TIME_PICKER_FORMAT = { hh: '12', mm: '00', ss: '00', a: 'am' }



// WEBPACK FOOTER //
// ./src/api/constants/Common.js